import { stringIds, bundleIds } from "@amzn/ziggy-asset";
import React from "react";
import { getLocalizedString } from "../../../../utils";
import {
    FullScreenConfirmationModal,
    IconsList,
} from "../../../components/common";
import { BundleMap } from "../../../../models";
import { useSelector } from "react-redux";
import { getBundleMap } from "../../../../store/selectors/commonSelectors";

const testIDPrefix = "ClaimTakeMeToVendorLabelFlowModal";

export const ClaimTakeMeToVendorLabelFlowModal: React.FC<{
    isVisible: boolean;
    onCancel: () => void;
    onContinue: () => void;
}> = ({ isVisible, onCancel, onContinue }) => {
    const bundleMap: BundleMap = useSelector(getBundleMap);

    return (
        <FullScreenConfirmationModal
            icon={IconsList.alerts_Information}
            text={getLocalizedString(bundleMap, {
                bundleId: bundleIds.CLAIMVENDORLABELTEAMTYPEMODAL_STRINGS,
                stringId: stringIds.ClaimVendorLabelTeamTypeModal.title,
            })}
            description={getLocalizedString(bundleMap, {
                bundleId: bundleIds.CLAIMVENDORLABELTEAMTYPEMODAL_STRINGS,
                stringId: stringIds.ClaimVendorLabelTeamTypeModal.description,
            })}
            confirmButtonText={getLocalizedString(bundleMap, {
                bundleId: bundleIds.GENERIC_STRINGS,
                stringId: stringIds.Generic.continue,
            })}
            cancelButtonText={getLocalizedString(bundleMap, {
                bundleId: bundleIds.GENERIC_STRINGS,
                stringId: stringIds.Generic.cancel,
            })}
            confirmButtonAction={onContinue}
            cancelButtonAction={onCancel}
            onDismiss={onCancel}
            isVisible={isVisible}
            id={`${testIDPrefix}_VendorLabelJobTitleModal`}
        />
    );
};
